import jobsManage from "./pages/jobs/store";
import ngoSlider from "./pages/images-slider/store";
import ngoCampaign from "./pages/campaigns/store";
import event from "./pages/events/store";
import statistics from "./pages/statistics/store";
import NewsManagement from "./pages/news/store";
import GuestMessages from "./pages/contact-us-messages/store";
import About from "./pages/about-ngo/store";
import PaymentMethods from "./pages/payment-management/store";

export default {
  namespaced: true,
  modules: {
    jobsManage,
    ngoSlider,
    ngoCampaign,
    event,
    statistics,
    NewsManagement,
    GuestMessages,
    About,
    PaymentMethods,
  },
};
